var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',[_c('div',{staticClass:"text-right"},[_c('div',{staticClass:"overline"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" KAMEOKA ELECTRONICS Co.,Ltd. ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }